import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { CmsLinkComponent } from '@spartacus/core';
import { CmsComponentData, GenericLinkModule, MediaContainer, MediaModule } from '@spartacus/storefront';
import { Observable } from 'rxjs';

export interface GgGridItemData {
  uid: string;
  image?: MediaContainer;
  link?: CmsLinkComponent;
}

@Component({
  selector: 'app-gg-grid-item',
  templateUrl: 'gg-grid-item.component.html',
  imports: [GenericLinkModule, CommonModule, MediaModule],
})
export class GgGridItemComponent {
  private componentData = inject(CmsComponentData<GgGridItemData>);

  data$: Observable<GgGridItemData> = this.componentData.data$;
}
